import React from 'react'

import { I_SystemPost } from '../state/wpDataStore'

const SystemAttributes = ({ systemPost }: { systemPost: I_SystemPost }) => {
  const { acf } = systemPost

  return acf ? (
    <div className='system-attributes'>
      {[
        ['capital_cost', 'Capital Cost'],
        ['carbon_savings', 'Carbon Savings'],
        ['space_required', 'Outdoor Space Requirements'],
        ['electricity_demands', 'Peak Electricity Demands'],
      ].map(([key, label]) =>
        acf[key] !== undefined ? (
          <AttributeItem key={key} label={label} value={String(acf[key])} />
        ) : null
      )}
    </div>
  ) : null
}

const AttributeItem = ({ label, value }: { label: string; value: string }) => (
  <div className='system-attributes__item'>
    <p className='system-attributes__item-label'>{label}</p>
    <p className='system-attributes__item-value'>{value}</p>
  </div>
)

export { SystemAttributes }
